const rankings = [
  { title: '藏海花', type: '电视剧', score: '9.2', desc: '南派三叔原著改编，吴邪探寻身世之谜，悬疑冒险巨制。', rank: 1, trend: 'up' },
  { title: '飞驰人生2', type: '电影', score: '8.8', desc: '沈腾、范丞丞爆笑出演，赛车喜剧再续热血传奇。', rank: 2, trend: 'up' },
  { title: '唐朝诡事录之西行', type: '电视剧', score: '9.0', desc: '古装悬疑探案，杨旭文、杨志刚解密西域奇案。', rank: 3, trend: 'up' },
  { title: '长相思 第二季', type: '电视剧', score: '8.9', desc: '杨紫、张晚意虐恋升级，命运交织的极致情感。', rank: 4, trend: 'new' },
  { title: '歌手2024', type: '综艺', score: '8.7', desc: '实力唱将巅峰对决，顶级音乐盛宴每周更新。', rank: 5, trend: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">热播榜单</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            根据实时播放量和用户评分综合排序，发现全网最受欢迎的热门影视
          </p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 p-4 md:p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer group"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-xl flex items-center justify-center flex-shrink-0 font-heading font-bold text-lg ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-secondary-400 text-background-50' :
                item.rank === 3 ? 'bg-primary-400 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 truncate">{item.title}</h3>
                  <span className="flex-shrink-0 px-2 py-0.5 rounded-md bg-background-200 text-xs text-foreground-600">{item.type}</span>
                  <span className="flex-shrink-0 text-xs font-bold text-accent-600">{item.score}分</span>
                </div>
                <p className="text-sm text-foreground-600 truncate">{item.desc}</p>
              </div>

              <div className="flex-shrink-0">
                <i className={`text-lg transition-colors ${
                  item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' :
                  item.trend === 'new' ? 'ri-sparkling-line text-accent-500' :
                  'ri-subtract-line text-foreground-400'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}